import { get, includes, sumBy } from 'lodash';

export const hasLoadedPageData = (state, teamId, fixtureId) => {
  const loadedPages = get(state, 'teams.matchCentre.loadedPages', []);
  return includes(loadedPages, `${teamId}-${fixtureId}`);
};

export const isLoadingPageData = (state, teamId, fixtureId) => {
  const loadingPages = get(state, 'teams.matchCentre.loadingPages', []);
  return includes(loadingPages, `${teamId}-${fixtureId}`);
};

export const getPageData = (state, teamId, fixtureId) =>
  get(state, `teams.matchCentre.pageData['${teamId}-${fixtureId}']`, {});

export const getPageLoadingError = (state, teamId, fixtureId) =>
  get(state, `teams.matchCentre.pageLoadingErrors['${teamId}-${fixtureId}']`);

export const getNewEvents = (state, teamId, fixtureId) =>
  get(getPageData(state, teamId, fixtureId), 'newEventsByPeriod', []);

export const getUpdateCount = (state, teamId, fixtureId) =>
  sumBy(getNewEvents(state, teamId, fixtureId), (period) => get(period, 'events', []).length);
